/**
 *  Return string without whitespace.
 */
export const removeWhitespace = (value: string | undefined) =>
    value ? value.replace(/ /g, '') : '';

/**
 *  Return string without non-numeric characters.
 */
export const removeNonNumbers = (value: string | undefined) =>
    value ? value.replace(/\D/g, '') : '';

/**
 * Transforming the typed value to a currency format that is easier to read
 */
export const addCurrencySpacing = (value: string): string => {
    const trimmedValue = removeWhitespace(value);
    if (trimmedValue.length > 3) {
        const lastIndex = trimmedValue.length;
        return `${addCurrencySpacing(trimmedValue.substring(0, lastIndex - 3))} ${trimmedValue.substring(lastIndex - 3)}`;
    }
    return trimmedValue;
};

// Number chars only, used to verify price
const numbersOnlyPattern = '^[0-9]*$';
const numberRegex = new RegExp(numbersOnlyPattern);

/**
 * Checking if a string only consists of chars 0-9.
 * Used to make sure users only enter number digits in the field.
 */
export const verifyNumbersOnly = (number: string) => numberRegex.test(number);

/**
 * Adds spacing to a phone number based on the country code.
 * Country code not included in the output.
 *
 * @param {string} phoneNumber - The phone number to format.
 * @param {string} countryCode - The country code to determine the formatting style.
 * @returns {string} The formatted phone number with appropriate spacing.
 */
export const addPhoneSpacing = (phoneNumber: string, countryCode: string) => {
    const plainPhoneNumber = removeNonNumbers(phoneNumber);

    if (countryCode === '+358') {
        return plainPhoneNumber.replace(/^0+/, '').replace(/(\d{2})(\d{3})(\d+)/, '$1 $2 $3');
    }

    if (countryCode === '+45') {
        return plainPhoneNumber.replace(/(\d{2})(\d{2})(\d{2})(\d+)/, '$1 $2 $3 $4');
    }

    return plainPhoneNumber.replace(/(\d{3})(\d{2})(\d+)/, '$1 $2 $3');
};

/**
 * Formats a phone number by adding appropriate spacing and including the country code.
 *
 * @param {string} phoneNumber - The phone number to format.
 * @param {string} countryCode - The country code to prepend to the phone number, defines spacing in the phone number sa well.
 * @returns {string} The formatted phone number.
 */
export const formatPhoneNumber = (phoneNumber: string, countryCode: string) =>
    `${countryCode} ${addPhoneSpacing(phoneNumber, countryCode)}`;
